<div class="Txt-Withdraw-Coinbase withdraw-dialog">
  <div class="paypal-header">
    <div class="paypal-text">{{ 'PAYOUT' | translate }}</div>
    <div class="close-svg" (click)="closeDialog()"></div>
  </div>
  <div class="paypal-container">
    <div class="paypal-icon-container">
      <image-loader-utils [url]="this.data.configItem.description.toLowerCase()" extraClasses="icon  payment-modal-icon"></image-loader-utils>
    </div>
    <div class="paypal-balance-text">
      <h2>{{ 'Balance' | translate }} {{ this._UserHelper.customerUser?.Balance }}</h2>
    </div>
    <form class="example-form" [formGroup]="WithdrawFormDatas">
      <div class="credit-input-container">
        <inputBase-decimal
          [extraClass]="'amountInput'"
          fPlaceholder="{{ 'Amount' | translate }}"
          fSuffixText="{{ this._UserHelper.customerUser.Symbol }}"
          formControlName="withdrawamount"
          [disabled]="true"></inputBase-decimal>
        <ng-container [ngSwitch]="this.data.configItem.additionalInfo">
          <ng-container *ngSwitchCase="'mail'">
            <inputBase fPlaceholder="{{ 'e_mail_address' | translate }}" fInputType="email" formControlName="mailadress" [extraClass]="'amountInput'"></inputBase>
          </ng-container>
          <ng-container *ngSwitchCase="'phone'">
            <inputBase fPlaceholder="{{ 'Phone_Number' | translate }}" fInputType="number" formControlName="phoneNumber" [extraClass]="'amountInput'"></inputBase>
          </ng-container>
        </ng-container>
      </div>
    </form>
    <div class="confirm-button-container" *ngIf="WithdrawFormDatas.valid; else noAmount" (click)="this._WithdrawService.confirmButton(WithdrawFormDatas)">
      <div class="btn colored register-button save-changes-button confirm-button">
        <div class="btn-text">{{ 'Confirm' | translate }}</div>
      </div>
    </div>
    <ng-template #noAmount>
      <div class="confirm-button-container">
        <div style="opacity: 0.5" class="btn colored register-button save-changes-button confirm-button opacity">
          <div class="btn-text">{{ 'Confirm' | translate }}</div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
